import React from 'react';
import VendorStepLogin from "../VendorStepLogin";
import HeaderResponsive from "../HeaderResponsive";
import IconName from "../../../svgLogo/SvgLogo";
import VendorPersonalInformation from "./VendorPersonalInformation";
import VendorPhoneInformation from "./VendorPhoneInformation";
import VendorCommercialInformation from "./VendorCommercialInformation";
import VendorModalPolicy from "./VendorModalPolicy";

const VendorInformation = () => {
    return (
        <div className="vendor-information-wrapper">
            <div className="modal-wrapper" id="vendor-modal-wrapper"></div>
            <div className="row">
                <div className="col-lg-5 order-2 order-lg-1 information-inputs-wrapper">
                    <VendorStepLogin/>
                </div>
                <div className="col-lg-7 order-1 order-lg-2 information-inputs-wrapper">
                    <HeaderResponsive/>
                    <div className="information-wrapper">
                        <div className="point-information">
                            <p className="text"><span className="point">نکته :</span> پر کردن تمامی موارد الزامیست</p>
                        </div>
                        <div className="choose-type-seller xmt-10 xmt-lg-12">
                            <span className="title-question">چه نوع فروشنده ای هستید؟</span>
                            <IconName name="help_outline" className="icon choose-seller-icon"/>
                            <div className="options-type-seller d-flex align-items-center xmt-8 xmt-lg-10">
                                <div className="form-check d-flex align-items-center">
                                    <input className="form-check-input" type="radio" name="flexRadioDefault"
                                           id="flex-radio-default--1"/>
                                    <label className="form-check-label" htmlFor="flex-radio-default--1">
                                        شخص حقیقی
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center xmr-6">
                                    <input className="form-check-input" type="radio" name="flexRadioDefault"
                                           id="flex-radio-default--2"/>
                                    <label className="form-check-label" htmlFor="flex-radio-default--2">
                                        شخص حقوقی
                                    </label>
                                </div>
                            </div>
                        </div>
                        <VendorPersonalInformation/>
                        <VendorPhoneInformation/>
                        <VendorCommercialInformation/>
                        <div className="button-next-page" id="open-policy-modal">
                            <div className="button-info">ثبت اطلاعات</div>
                        </div>
                    </div>
                </div>
            </div>
            <VendorModalPolicy/>
        </div>
    );
};

export default VendorInformation;
